import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Credentials } from "../models/Credentials";

@Injectable()
export class AuthService {

    url = `${environment.apiBaseUrl}/auth`;

    constructor(private http: HttpClient) { }

    authenticate(item: Credentials) {
        return this.http.post(`${this.url}/login`, item);
    }

    logout() {
        return this.http.delete(`${this.url}/logout`);
    }
}